import { useEffect, useState } from "react";
import { Upload } from "lucide-react";

export function PassportCopyUpload({ fileName, awaitingVerification, es, onChoose, onFiles }: {
  fileName: string; awaitingVerification: boolean; es: boolean;
  onChoose: () => void; onFiles: (files: File[]) => void;
}) {
  return <div className="passport-copy-upload">
    <div className="passport-copy-text">
      <h3>{es ? "Copia del pasaporte" : "Passport copy"}</h3>
      <p>{fileName || (es ? "PDF no subido" : "No PDF uploaded")}</p>
      {awaitingVerification && <p>{es ? "Pasaporte pendiente de verificación" : "Passport awaiting verification"}</p>}
    </div>
    <PassportPdfDropZone fileName={fileName} es={es} onChoose={onChoose} onFiles={onFiles} />
  </div>;
}

export function PassportPdfDropZone({fileName, es, onChoose, onFiles}: {
 fileName: string; es: boolean; onChoose: () => void; onFiles: (files: File[]) => void;
}) {
 const [dragging, setDragging] = useState(false);
 const [dropEnabled, setDropEnabled] = useState(false);
 useEffect(() => {
   const pointer = window.matchMedia("(hover: hover) and (pointer: fine)");
   const update = () => {
     setDropEnabled(pointer.matches && navigator.maxTouchPoints === 0);
     setDragging(false);
   };
   update();
   pointer.addEventListener("change", update);
   return () => pointer.removeEventListener("change", update);
 }, []);
 return (
    <button type="button" className={`passport-copy-drop${dragging ? " is-dragging" : ""}`}
      data-drop-enabled={dropEnabled}
      aria-label={fileName ? (es ? "Reemplazar PDF" : "Replace PDF") : (es ? "Elegir PDF del pasaporte" : "Choose passport PDF")}
      onClick={onChoose}
      onDragOver={event => { event.preventDefault(); event.dataTransfer.dropEffect = dropEnabled ? "copy" : "none"; if (dropEnabled) setDragging(true); }}
      onDragLeave={event => { if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setDragging(false); }}
      onDrop={event => { event.preventDefault(); setDragging(false); if (dropEnabled) onFiles(Array.from(event.dataTransfer.files)); }}>
      <Upload size={22} aria-hidden="true" />
      <span className="passport-copy-drop-hint passport-copy-desktop">{es ? "Arrastre su PDF aquí" : "Drop your PDF here"}</span>
      <span className="passport-copy-file-action">{fileName ? (es ? "Reemplazar PDF" : "Replace PDF") : <>
        <span className="passport-copy-desktop">{es ? "Elegir archivo" : "Choose file"}</span>
        <span className="passport-copy-mobile">{es ? "Elegir PDF del pasaporte" : "Choose passport PDF"}</span>
      </>}</span>
    </button>
 );
}
